module.exports = __webpack_public_path__ + "img/RTB-front.d58d19ff.png";